<template>
  <div id="app" class="bg-custom" style="height: 100vh">
    <b-container v-if="langLoad" fluid>
      <b-navbar v-if="isLoggedIn" toggleable="lg" type="dark" variant="custom">
        <b-navbar-brand>
            <img :height="brandLogoHeight" :alt="brandAlt" :src="brandLogo">
        </b-navbar-brand>

        <b-navbar-toggle target="nav-collapse"></b-navbar-toggle>

        <b-collapse  id="nav-collapse" is-nav>
          <b-navbar-nav>
            <b-nav-item
                class="toolbar-item"
                to="/devices"
                active-class="active"
            >
              <icon-base icon-name="envelope" class="toolbar-item-icon"><dev-icon /></icon-base>
              <span class="toolbar-item-text">{{$t('menu.devices')}}</span>
            </b-nav-item>
            <b-nav-item-dropdown
                class="toolbar-item"
                active-class="active"
                v-if="monitoringAvailable()"
            >
                <template slot="button-content">
                    <b-icon-search class="toolbar-item-icon" />
                    <span class="toolbar-item-text">{{$t('settings.monitoring')}}</span>
                </template>
                <b-dropdown-item to="/monitoring">{{$t('menu.devices')}}</b-dropdown-item>
                <b-dropdown-item to="/messages">{{$t('menu.messages')}}</b-dropdown-item>
                <b-dropdown-item to="/history">{{$t('menu.monitoring.history')}}</b-dropdown-item>
                <b-dropdown-divider />
                <b-dropdown-item to="/device-groups">{{$t('menu.groups')}}</b-dropdown-item>
                <b-dropdown-item to="/device-props">{{$t('menu.device_props')}}</b-dropdown-item>
            </b-nav-item-dropdown>
            <b-nav-item
                class="toolbar-item"
                to="/devicesGroupActions"
                active-class="active"
            >
                  <b-icon-card-checklist></b-icon-card-checklist>
              <span class="toolbar-item-text">
              {{$t('group_management')}}
              </span>
            </b-nav-item>
            <b-nav-item-dropdown
                class="toolbar-item"
                type="dark"
            >
                <!-- Using 'button-content' slot -->
                <template v-slot:button-content>
                  <icon-base icon-name="admin" class="toolbar-item-icon"><admin-icon /></icon-base>
                  <span class="toolbar-item-text">
                  {{$t('menu.administration')}}
                    </span>
                </template>
<!--                <b-dropdown-item to="/devicesGroupActions">{{ $t('group_management') }}</b-dropdown-item>-->
                <b-dropdown-item
                    to="/saved-configurations"
                    active-class="active"
                >{{ $t('menu.configurations') }}</b-dropdown-item>
                <b-dropdown-item
                    to="/firmwares"
                    active-class="active"
                >{{ $t('menu.firmwares') }}</b-dropdown-item>
                <span v-if="user.futureAvailable.users">
                  <b-dropdown-item
                      to="/users"
                      active-class="active"
                  >{{ $t('users') }}</b-dropdown-item>
                </span>
                <span v-if="user.futureAvailable.organisations">
                  <b-dropdown-item
                      to="/organisations"
                      active-class="active"
                  >{{ $t('organisations') }}</b-dropdown-item>
                </span>
                <span v-if="user.futureAvailable.deviceRegister">
                  <b-dropdown-item
                      to="/device-register"
                      active-class="active"
                  >{{ $t('menu.device_register') }}</b-dropdown-item>
                </span>
            </b-nav-item-dropdown>
            <b-navbar-brand :href="getAppLink()">
              <img src="assets/images/icons8-android-os-100.png" alt="" width="20px">
                <span class="toolbar-item-text">
                    {{$t('android_app')}}
                </span>
            </b-navbar-brand>
            <b-navbar-brand :href="getUsbLink()">
              <img src="assets/images/icons8-usb-64.png" alt="" width="20px">
                <span class="toolbar-item-text">
                    {{$t('pc_app')}}
                </span>
            </b-navbar-brand>
          </b-navbar-nav>

<!--          <select v-model="themeHelper.theme">-->
<!--            <option v-for="(href, name) of themes" v-bind:value="name" :key="href">-->
<!--              {{ name }}-->
<!--            </option>-->
<!--          </select>-->
<!--          <span>Selected: {{ themeHelper.theme }}</span>-->

          <!-- Right aligned nav items -->
          <b-navbar-nav class="ml-auto">

            <b-nav-item-dropdown
                v-if="!isLoggedIn"
                    :text="getCurrentLang()"
                    right
            >
              <b-dropdown-item
                      v-for=" lang of langList"
                      :key="lang.id"
                      @click="updateLang(lang.id)"
              >{{lang.name}}
              </b-dropdown-item>
            </b-nav-item-dropdown>
            <b-nav-item-dropdown v-if="!isBusy" right>
              <!-- Using 'button-content' slot -->
              <template v-slot:button-content>
                <em>{{user.name}} </em>
<!--                <em>{{user.company.identity}} </em>-->
<!--                  <b-icon-files-->
<!--                      v-b-tooltip.hover-->
<!--                      :title="$t('device_list.coll.imei.copy')"-->
<!--                      @click="doCopy(user.company.identity)"-->
<!--                  ></b-icon-files>-->
              </template>
                <b-dropdown-item
                    to="/user-info"
                    active-class="active"
                >{{ $t('menu.user_info') }}</b-dropdown-item>
              <b-dropdown-item >{{user.company.name}}</b-dropdown-item>
              <b-dropdown-item @click="doCopy(user.company.identity)">{{user.company.identity}}</b-dropdown-item>
              <b-dropdown-item @click="logout">{{$t('sign_out')}}</b-dropdown-item>
            </b-nav-item-dropdown>
          </b-navbar-nav>
        </b-collapse>
      </b-navbar>

    </b-container>

    <b-container fluid  v-if="langLoad">
        <b-spinner v-if="isLoggedIn && profileLoading" :label="$t('profile_loading')" />
        <b-alert v-if="isLoggedIn && profileError" variant="danger" show class="profile-load-error">
            {{$t('user_load_error')}} <b-button class="profile-load-retry" @click="getUser">{{$t('retry')}}</b-button>
        </b-alert>
        <router-view v-if="!isLoggedIn || !profileLoading" :user="user" ></router-view>
    </b-container>
  </div>
</template>
<script>
import { normalizePermissions } from './utils/Permissions';
import { REQUEST_TIMEOUT_MS } from './utils/RequestGuard';

import axios from "axios";
import IconBase from "./components/Icons/IconBase24.vue";
import DevIcon from "./components/Icons/icons/DevIcon.vue";
import AdminIcon from "./components/Icons/icons/AdminIcon.vue";
import {loadLanguageAsync, langLoad} from './i18n.ts'
// import ThemeHelper from './themeHelper.js'
import './custom1.scss'
import {
  localize
} from "vee-validate";

const mixinDetectingMobile = {
  methods: {
      doCopy: function (item) {
          this.$copyText(item).then(function () {
          }, function () {
              alert('Can not copy')
              // console.log(e)
          })
      },
    isMobile: function () {
      let check = false;
      (function (a) {
        if (/(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|mobile.+firefox|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows ce|xda|xiino/i.test(a) || /1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\\-(n|u)|c55\/|capi|ccwa|cdm\\-|cell|chtm|cldc|cmd\\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\\-s|devi|dica|dmob|do(c|p)o|ds(12|\\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\\-|_)|g1 u|g560|gene|gf\\-5|g\\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\\-(m|p|t)|hei\\-|hi(pt|ta)|hp( i|ip)|hs\\-c|ht(c(\\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\\-(20|go|ma)|i230|iac( |\\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\\-[a-w])|libw|lynx|m1\\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\\-2|po(ck|rt|se)|prox|psio|pt\\-g|qa\\-a|qc(07|12|21|32|60|\\-[2-7]|i\\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\\-|oo|p\\-)|sdk\/|se(c(\\-|0|1)|47|mc|nd|ri)|sgh\\-|shar|sie(\\-|m)|sk\\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\\-|v\\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\\-|tdg\\-|tel(i|m)|tim\\-|t\\-mo|to(pl|sh)|ts(70|m\\-|m3|m5)|tx\\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\\-|your|zeto|zte\\-/i.test(a.substr(0, 4))) check = true;
      })(navigator.userAgent || navigator.vendor || window.opera);
      return check;
    }
  }
};


export default {
    name: 'App',
    components: {
      IconBase,
      DevIcon,
      AdminIcon,
    },
    mixins: [mixinDetectingMobile],
    computed : {
        isLoggedIn : function(){ return this.$store.getters.isLoggedIn},
        sessionToken : function(){ return this.$store.state.token; },
        isLangLoad : function(){ return langLoad},
        lang : {
          get() {
            return this.$store.getters.getLang || this.defaultLang;
          },
          set(value) {
            this.$store.commit('selLang', {lang: value})
            this.loadLanguageAsync(value)
            localize(value);
          }
        },
    },
    methods: {
        loadLanguageAsync: function(lang) {
            this.langLoad = false;
            return loadLanguageAsync(lang).then(() => {
                this.langLoad = true;
            });
        },
        logout: function () {
            this.$store.dispatch('logout')
                .then(() => {
                    this.$router.push('/login')
                })
        },
        clearLocate: function () {
            this.$store.commit('clearLang');
        },
        updateLang: function (value) {
          this.$store.commit('selLang', {lang: value})
          this.loadLanguageAsync(value)
          localize(value);
          location.reload();
        },
        getCurrentLang: function() {
            for (let lng in this.langList) {
              if (this.langList[lng].id === this.lang) {
                return this.langList[lng].name
              }
            }

            return this.defaultLang;
        },
        getAppLink: function () {
            if (this.getCurrentLang() === 'RU') {
                return process.env.VUE_APP_APP_LINK_RU;
            }

            return process.env.VUE_APP_APP_LINK_EN;
        },
        getUsbLink: function () {
            if (this.getCurrentLang() === 'RU') {
                return process.env.VUE_APP_USB_LINK_RU;
            }

            return process.env.VUE_APP_USB_LINK_EN;
        },
        resetProfile() {
            this.profileRequest = (this.profileRequest || 0) + 1;
            this.profileLoading = false; this.profileError = false; this.isBusy = true;
            this.user.name = null; this.user.company.name = null; this.user.company.identity = null;
            this.user.futureAvailable = normalizePermissions(null);
            localStorage.removeItem('futureAvailable');
        },
        getUser: function () {
            const request = this.profileRequest = (this.profileRequest || 0) + 1;
            const token = localStorage.getItem('token');
            this.profileLoading = true; this.profileError = false; this.isBusy = true;
            this.user.name = null; this.user.company.name = null; this.user.company.identity = null;
            this.user.futureAvailable = normalizePermissions(null);
            localStorage.removeItem('futureAvailable');
            const current = () => !this.profileDisposed && request === this.profileRequest && token === localStorage.getItem('token');
            return axios.get('api/v1/users/info', { timeout: REQUEST_TIMEOUT_MS })
                .then(({ data }) => {
                    if (!current()) return;
                    if (!data || !data.company || typeof data.name !== 'string') throw new Error('Invalid profile');
                    this.user.name = data.name;
                    this.user.company.name = data.company.name;
                    this.user.company.identity = data.company.identity;
                    this.user.futureAvailable = normalizePermissions(data.futureAvailable);
                    localStorage.setItem('futureAvailable', JSON.stringify(this.user.futureAvailable));
                })
                .catch(error => {
                    if (!current()) return;
                    if (error.response?.status !== 401) this.profileError = true;
                    this.$emit('load-error', error);
                })
                .finally(() => { if (current()) { this.profileLoading = false; this.isBusy = false; } });
        },
        monitoringAvailable()  {
            return this.user.futureAvailable.monitoring;
        }
    },
    watch: {
      sessionToken: function(val) {
        if (val) {
            this.getUser();
        } else { this.resetProfile(); }
      }
    },
    data() {
        function getLangList() {
            const langsCongig = process.env.VUE_APP_LANGS.split(",");

            const langs = {
                ru: {id: "ru", name: 'RU'},
                en: {id: "en", name: 'EN'}
            };

            let data = [];

            langsCongig.forEach(
                (lang) => {
                    data.push(langs[lang]);
                }
            );

            return data
        }
        return {
            brandAlt: process.env.VUE_APP_NAME,
            brandLogo: 'assets/logo/' + process.env.VUE_APP_LOGO,
            brandLogoHeight: process.env.VUE_APP_LOGO_HEIGHT + 'px',

            langLoad: false,
            langList: getLangList(),
            defaultLang: process.env.VUE_APP_DEFAULT_LANG,
            isBusy: true,
            profileLoading: true, profileError: false, profileRequest: 0, profileDisposed: false,
            user: {
                name: null,
                company: {
                    name: null,
                    identity: null,
                },
                futureAvailable: normalizePermissions(null)
            },
            themes: {
              darkly: "https://bootswatch.com/4/darkly/bootstrap.min.css",
              flatly: "https://bootswatch.com/4/flatly/bootstrap.min.css",
              materia: "https://bootswatch.com/4/materia/bootstrap.min.css",
              solar: "https://bootswatch.com/4/solar/bootstrap.min.css",
              slate: "https://bootswatch.com/4/slate/bootstrap.min.css",
              cyborg: "https://bootswatch.com/4/cyborg/bootstrap.min.css",
              superhero: "https://bootswatch.com/4/superhero/bootstrap.min.css",
              minty: "https://bootswatch.com/4/minty/bootstrap.min.css",
              sandstone: "https://bootswatch.com/4/sandstone/bootstrap.min.css",
              simplex: "https://bootswatch.com/4/simplex/bootstrap.min.css",
              spacelab: "https://bootswatch.com/4/spacelab/bootstrap.min.css",
              yeti: "https://bootswatch.com/4/yeti/bootstrap.min.css",
            },
            // themeHelper: new ThemeHelper(),
            loading: true,
        }
    },
    beforeDestroy() { this.profileDisposed = true; this.profileRequest++; },
    mounted() {
        this.clearLocate();
        if (this.isLoggedIn) this.getUser();
        this.loadLanguageAsync(this.lang);
    },
    created() {
      // add/load themes
      // let added = Object.keys(this.themes).map(name => {
      //   return this.themeHelper.add(name, this.themes[name]);
      // });

      // Promise.all(added).then(sheets => {
      //   console.log(`${sheets.length} themes loaded`);
      //   this.loading = false;
      //   this.themeHelper.theme = "flatly";
      // });
    },
}
</script>

<style lang="scss" scoped>
    .toolbar-item {
        display: flex;
        flex-direction: row;
        align-items: center;

        .toolbar-item-text {
            font-size: 16px;
        }

        .toolbar-item-icon {
            margin-right: 0.25em;
        }
    }

</style>
